import React from "react";
import logo from "../../assets/logo.png";
import iconLogo from "../../assets/icon-logo.png";

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export function AuthLayout({
  children,
  title = "WELCOME BACK",
}: AuthLayoutProps) {
  return (
    <main
      className="box-border flex justify-center items-center p-5 w-screen h-screen min-h-[600px] max-md:p-4 max-sm:p-3"
      style={{
        background: "radial-gradient(circle, #414141 0%, #1B1B1B 100%)",
      }}
    >
      <div className="flex justify-center items-center max-w-screen-xl size-full">
        <div className="flex flex-col gap-5 justify-center items-center">
          <img src={logo} alt="Vietnamyounglion Logo" className={`w-[80%]`} />

          <div className="box-border flex relative flex-col gap-4 justify-center items-center px-10 py-7 w-[407px] max-md:px-12 max-md:py-6 max-md:w-[350px] max-sm:px-8 max-sm:py-5 max-sm:w-[300px]">
            <div
              className="absolute top-0 left-0 rounded-xl shadow-lg size-full z-[1]"
              style={{
                background:
                  "linear-gradient(to bottom, #D9D6D6 0%, #B5AEAD 100%)",
              }}
            />

            <img
              src={iconLogo}
              alt="Welcome illustration"
              className="object-contain relative h-[92px] w-[85px] z-[2]"
            />
            {title && (
              <header className="relative text-base font-bold text-center h-[21px] text-stone-700 w-[200px] z-[2] max-sm:text-sm">
                {title}
              </header>
            )}

            {children}
          </div>
        </div>
      </div>
    </main>
  );
}

export default AuthLayout;
